export default class UserDefaultAddressRequestData {
  public name?: string | null
  public city?: string | null
  public street?: string | null
  public tax_number?: string | null
  public vat_iso_prefix?: string | null
  public postal_code?: string | null
  public country_iso_code?: string | null
}
